import { render, staticRenderFns } from "./DepartmentCard.vue?vue&type=template&id=4fcc437f&scoped=true"
import script from "./DepartmentCard.vue?vue&type=script&lang=js"
export * from "./DepartmentCard.vue?vue&type=script&lang=js"
import style0 from "./DepartmentCard.vue?vue&type=style&index=0&id=4fcc437f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcc437f",
  null
  
)

export default component.exports